//import './selection-state-handler.scss';
//import Hammer from 'hammerjs';
import {deltaDeviceRect,getDevicePagePoint} from './util.js';
import DebouncePromiseQueue from './DebouncePromiseQueue'

function createSelectionStateHandler(UIExtension) {
    let $ = UIExtension.jQuery;
    let Hammer = UIExtension.Hammer;
    let Events = UIExtension.PDFViewCtrl.Events;
    //let module = UIExtension.modular.module('online');

    class SelectTextStateHandler extends UIExtension.PDFViewCtrl.IStateHandler {
        constructor(pdfViewer) {
            super(pdfViewer);
        }
        // static getName() {
        //     return 'select-text-annotation';
        // }
        static getStateName() {
            return 'ai-select-text'
        }
        static getDefaultContextMenuConfig () {
            return {
                //selector: '.fv__selection-state-contextmenu-container'
            };
        }
        pageHandler (pageRender) {
            this.pageRender = pageRender;
            this.pdfViewer = pageRender.pdfViewer;
            this.selectMarkIsVisible = false;
            const tooltip = this.tooltip = this.pdfViewer.viewerUI.createTextSelectionTooltip(pageRender);
    
            let that = pageRender;
            pageRender.$ui.addClass('fv__annot-container-zindex-up');
            let $handler = that.$handler;
            $handler.addClass('fv__select-text-annotation-state-handler');
            let eHandler = $handler[0];
            let pdfViewer = pageRender.pdfViewer;
            let eventEmitter = pdfViewer.eventEmitter;
    
            (() => {
                const listener = pr => {
                    if(pr != pageRender || !this.pdfSelectRectArray || !this.selectMarkIsVisible) {
                        return;
                    }
                    pageRender.getPDFPage().then(page => {
                        const rectArrayInPixel = pageRender.transformRectArray(page, this.pdfSelectRectArray);
                        this.showSelectMark(rectArrayInPixel);
                        const firstRect = rectArrayInPixel[0];
                        if(!firstRect) {
                            return;
                        }
                        tooltip.showAt((firstRect.left + firstRect.right) / 2, firstRect.top, this.selectText, rectArrayInPixel);
                    });
                };
                eventEmitter.on(Events.renderPageSuccess, listener);
                this.removeRenderPageSuccessEvent = () => {
                    eventEmitter.off(Events.renderPageSuccess, listener);
                };
            })()
    
            // We create a manager object, which is the same as Hammer(), but without the presetted recognizers.
            let hammer = this.hammer = new Hammer.Manager(eHandler, {
                recognizers: [
                    [Hammer.Pan, { direction: Hammer.DIRECTION_ALL }]
                ]
            });
            // Tap recognizer with minimal 2 taps
            hammer.add( new Hammer.Tap({ event: 'doubletap', taps: 2 }) );
            // Single tap recognizer
            hammer.add( new Hammer.Tap({ event: 'singletap' }) );
            // we want to recognize this simulatenous, so a quadrupletap will be detected even while a tap has been recognized.
            hammer.get('doubletap').recognizeWith('singletap');
            // we only want to trigger a tap, when we don't have detected a doubletap
            hammer.get('singletap').requireFailure('doubletap');
    
            hammer.on('singletap', (e) => {
                this.hideSelectMark();
                tooltip.hide();
                let annotsRender = pageRender.annotsRender;
                if (!annotsRender) {
                    eventEmitter.emit(Events.tapPage, e);
                    return;
                }
                annotsRender.unActiveAnnot();
                eventEmitter.emit(Events.tapPage, e);
            });
            hammer.on('doubletap', (e) => {
                this.hideSelectMark();
                tooltip.hide();
                let annotsRender = pageRender.annotsRender;
                if (!annotsRender) {
                    eventEmitter.emit(Events.doubleTapPage, e);
                    return;
                }
                annotsRender.unActiveAnnot();
                eventEmitter.emit(Events.doubleTapPage, e);
            });
            tooltip.on('hide', () => {
                this.hideSelectMark();
            });
    
            let startPoint;
            let start = -1;
            let end = -1;
            let text;
            let debouncePromiseQueue;
            hammer.on('panstart', (e) => {
                if (this.panStart(e, this) === false) {
                    return;
                }
    
                start = -1;
                end = -1;
                text = undefined;
                let annotsRender = pageRender.annotsRender;
                if (annotsRender) {
                    annotsRender.unActiveAnnot();
                }
                let point = getDevicePagePoint(eHandler,e)
                startPoint = [point.x,point.y];
                this.hideSelectMark();
                debouncePromiseQueue = new DebouncePromiseQueue();
            });
            hammer.on('panmove', (e) => {
                if (this.panMove(e, this) === false){
                    return;
                }
    
                debouncePromiseQueue.push(() => {
                    let pageRender = this.pageRender;
                    //const deviceRect = deltaDeviceRect(startPoint, e.deltaX, e.deltaY);
                    const endPoint = [startPoint[0] + e.deltaX, startPoint[1] + e.deltaY];
                    return this.getTextRect(startPoint, endPoint, start, end).then((rectArray) => {
                        let one = rectArray[0];
                        if (one) {
                            if (typeof one.text === 'string') {
                                start = one.start;
                                end = one.end;
                            }
                        }
                        return Promise.all([pageRender.getPDFPage(), rectArray]);
                    }).then(([page, rectArray]) => {
                        return pageRender.transformRectArray(page, rectArray);
                    }).then((rectArray) => {
                        // console.info(rectArray);
                        this.showSelectMark(rectArray);
                    })
                });
            });
            hammer.on('panend', (e) => {
                if (this.panEnd(e, this) === false){
                    return;
                }
    
                debouncePromiseQueue.end();
                debouncePromiseQueue = null;
    
                let deviceRect = deltaDeviceRect(startPoint, e.deltaX, e.deltaY);
                const endPoint = [startPoint[0] + e.deltaX, startPoint[1] + e.deltaY];
                //this.deviceSelectRect = deviceRect;
                // console.info(startPoint, endPoint, start, end);
                return this.getTextRect(startPoint, endPoint, start, end).then((rectArray) => {
                    let one = rectArray[0];
                    if (one) {
                        if (typeof one.text === 'string') {
                            start = one.start;
                            end = one.end;
                            text = one.text;
                        }
                        // console.info('first rect', one)
                    }
                    return Promise.all([pageRender.getPDFPage(), rectArray]);
                }).then(([page, rectArray]) => {
                    this.pdfSelectRectArray = rectArray;
                    const rectArrayInPixel = pageRender.transformRectArray(page, rectArray);
                    this.showSelectMark(rectArrayInPixel);
                    (typeof text === 'string' ? Promise.resolve(text) : this.getTextChar(deviceRect)).then((text) => {
                        this.pdfViewer.getStore().dispatch('viewer--store-selection-info', {
                            page,
                            text,
                            rectArray
                        });
                        this.selectText = text;
                        this.pdfViewer.eventEmitter.emit(Events.selectText, { page, text, rectArray, e });
                    });
                    const firstRect = rectArrayInPixel[0];
                    if(!firstRect) {
                        return;
                    }
                    tooltip.showAt((firstRect.left + firstRect.right) / 2, firstRect.top, this.selectText, rectArrayInPixel);
                });
    
            });
            
            let $div = $('<div class="fv__selection-state-contextmenu-container fv__contextmenu-container"></div>');
            $handler.append($div);
            $div.data('hand-state', this);
            this.$contextmenuContainer = $div;
        }
    
        getTextRect (startPoint, endPoint, start, end) {
            return this.pageRender.getTextContinueRectAtDevicePoints(startPoint, endPoint, start, end);
            //return this.pageRender.getTextContinueRectAtDeviceRect(rect);
        }
        getTextChar (rect) {
            return this.pageRender.getTextContinuousCharAtDeviceRect(rect);
        }
        showSelectMark (deviceRectArray) {
            this.selectMarkIsVisible = true;
            let $handler = this.pageRender.$handler;
            $handler.find('.fv__mark-selection-blank').remove();
            let $frag = $(document.createDocumentFragment());
            for (let i = 0, j = deviceRectArray.length; i < j; i++) {
                let rect = deviceRectArray[i];
                let style = ['top:' + rect.top + 'px', 'left:' + rect.left + 'px', 'height:' + (rect.bottom - rect.top) + 'px', 'width:' + (rect.right - rect.left) + 'px'].join(';')
                $frag.append('<mark class="fv__mark-selection-blank" style="' + style + '"></mark>')
            }
            $handler.append($frag);
        }
        hideSelectMark () {
            this.selectMarkIsVisible = false;
            this.pdfViewer.getStore().dispatch('viewer--store-selection-info', null);
            this.pageRender.$handler.find('.fv__mark-selection-blank').remove();
        }
  
        panStart () {
    
        }
        panMove () {
    
        }
        panEnd () {
    
        }
        destroyPageHandler () {
            this.hammer && this.hammer.destroy();
            this.pageRender.$ui.removeClass('fv__annot-container-zindex-up');
            this.pageRender.$handler.off('mouseup', this.mouseup).removeClass('fv__select-annotation-state-handler');
            this.$contextmenuContainer && this.$contextmenuContainer.remove();
            this.pageRender.annotsRender && this.pageRender.annotsRender.unActiveAnnot();
            this.hideSelectMark();
            this.tooltip.destroy();
            this.removeRenderPageSuccessEvent();
        }
        out () {
            this.destroyPageHandler()
        }
    }
    //module.registerController(SelectTextStateHandler);
    return SelectTextStateHandler;
}
export  {
    createSelectionStateHandler
}

